import { Box, Menu } from "@mui/material";
import { TooltipCC } from "components/common";
import TextFieldVMP from "components/common/TextField/TextFieldVMP";
import { useRef, useState } from "react";
import "./index.css";

const rowCalendar = [
    [1,2,3,4,5,6,7],
    [8,9,10,11,12,13,14],
    [15,16,17,18,19,20,21],
    [22,23,24,25,26,27,28],
    [29,30,31,32]
]


export function DatePickerCustom({selectedDayMonth, setSelectedDayMonth, t, valueMonth}){
    // const [openCalendar, setOpenCalendar] = useState(false);;
    const wrapperRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };

    const handleClickDay = (event) => {
        setAnchorEl('')
        if(!parseInt(event.target.textContent)){
            setSelectedDayMonth([32])
        } else setSelectedDayMonth([parseInt(event.target.textContent)]);
        
        // setOpenCalendar(false)
    }

    // function useOutsideAlerter(ref) {
    //     useEffect(() => {
    //         /**
    //          * Alert if clicked on outside of element
    //          */
    //         function handleClickOutside(event) {
    //             if (ref.current && !ref.current.contains(event.target)) {
    //                 setOpenCalendar(false);
    //             }
    //         }
    //         // Bind the event listener
    //         document.addEventListener('mousedown', handleClickOutside);
    //         return () => {
    //             // Unbind the event listener on clean up
    //             document.removeEventListener('mousedown', handleClickOutside);
    //         };
    //     }, [ref]);
    // }

    // useOutsideAlerter(wrapperRef);

    return (
        <div
        style={{position: "relative", width: '100%'}}
        ref={wrapperRef}
        >
            <Box onClick={handleClick} >
                {
                    valueMonth === 1 &&
                    <TooltipCC title={t('room.calendar-img')}>
                    <img 
                            id={'icon-date-2'}
                            className={'icon-calender-right'}
                            src={require('../../../../assets/img/icon-calendar.svg').default}
                            alt=""
                            style={{position: 'absolute', top: '6px', right: '5px'}}
                        />
                    </TooltipCC>
                }
                <TextFieldVMP
                    disabled={valueMonth === 2 ? true : false}
                    id="input-date" 
                    variant="outlined" 
                    fullWidth 
                    size="small" 
                    
                    value={selectedDayMonth[0] === 32 ? t('room.desc-monthly.text6') : selectedDayMonth[0]}
                />
            </Box>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                {rowCalendar.map((row, index) => (
                    <div key={index} className="row-calendar" style={{display: index === 0 ? 'flex' : 'block', position: row === rowCalendar[rowCalendar.length - 1] ? 'relative' : 'unset'}}>
                        {row.map((r, index) => (
                            <div key={index} className={selectedDayMonth[0] === r ? "number number-selected" : "number"} value={r} onClick={handleClickDay} style={r === 32 ? {display:"inline", position: 'absolute', right: 0, minWidth: '118px'} : {}}>{r === 32 ? t('room.desc-monthly.text6') : r}</div>
                        ))}
                    </div>
                ))}
            </Menu>
            {/* <div className="calendar" style={(openCalendar && valueMonth == 1) ? {display:"inline-block", border: "1px solid #aeaeae", borderRadius: "5px", backgroundColor: "white"} : {display:"none"}}>
                {rowCalendar.map((row, index) => (
                    <div key={index} className="row-calendar" style={{display: index === 0 ? 'flex' : 'block', position: row === rowCalendar[rowCalendar.length - 1] ? 'relative' : 'unset'}}>
                        {row.map((r, index) => (
                            <div key={index} className={selectedDayMonth[0] === r ? "number number-selected" : "number"} value={r} onClick={handleClickDay} style={r === 32 ? {display:"inline", position: 'absolute', right: 0, minWidth: '118px'} : {}}>{r === 32 ? t('room.desc-monthly.text6') : r}</div>
                        ))}
                    </div>
                ))}
            </div> */}
        </div>
        
    )
}
